module.exports = __webpack_public_path__ + "img/left.dd93a2d1.png";